import { render, staticRenderFns } from "./role-list.vue?vue&type=template&id=2fe7a4d2&"
import script from "./role-list.vue?vue&type=script&lang=js&"
export * from "./role-list.vue?vue&type=script&lang=js&"
import style0 from "./role-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "role-list.vue"
export default component.exports